import { render, staticRenderFns } from "./SvehicleinvoiceCreate.vue?vue&type=template&id=b34f97c0&scoped=true"
import script from "./SvehicleinvoiceCreate.vue?vue&type=script&lang=js"
export * from "./SvehicleinvoiceCreate.vue?vue&type=script&lang=js"
import style0 from "./SvehicleinvoiceCreate.vue?vue&type=style&index=0&id=b34f97c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34f97c0",
  null
  
)

export default component.exports